import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import List from './List';
import Save from './Save';

const StepsTab: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/novo`} component={Save} />
      <Route path={`${path}/:stepId`} component={Save} />
    </Switch>
  );
};

export default StepsTab;
